// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"118":"component---src-pages-aqi-js","196":"ee8b1517","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"118":"f78c0f2d6bb5d44b9835","196":"4ded2f91a7a2d65cb507","532":"9358739d364dae5d8443","678":"0928ac1d50355557341b"}[chunkId] + ".js";
};